import React, { useEffect, useState } from "react";
import {
  Button,
  ErrataWidget,
  Icon,
  Text,
} from "../../../personal-studio-components/studio";
import * as cls from "./modalAttestationTheme.module.scss";
import { useSelector } from "react-redux";
import { Snackbar } from "@mui/material";
import LinearLoader from "../linearLoader/LinearLoader";
import { StudentService } from "../studentService";
function ModalAttestationTheme() {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [spreadTheme, setSpreadTheme] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(null);
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const toggleDropdown = () => setIsOpen(!isOpen);
  const [response, setResponse] = useState(null);

  const selectTheme = (theme) => {
    setSelectedTheme(theme.diplom_theme_id);
    setIsOpen(false);
  };
  async function getVkrThemes() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/vkr/themes",
        data: {
          access_token,
          study_contract_id: contractId,
        },
      };
      const response = await StudentService.send(request, setResponse);
      setData(response);
      if (response.errors) {
        const errorEvent = new ErrorEvent("error", {
          error: response,
        });
        window.dispatchEvent(errorEvent);
      }
    }
  }

  async function choiseVkrTheme() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/vkr/choose_theme",
        data: {
          access_token,
          study_contract_id: contractId,
          diplom_theme_id: selectedTheme,
          extended_theme: spreadTheme.trim(),
        },
      };
      setIsLoading(true);
      const response = await StudentService.send(request, setResponse);
      if (!response.errors) {
        await getVkrThemes();
      } else {
        const errorEvent = new ErrorEvent("error", {
          error: response,
        });
        window.dispatchEvent(errorEvent);
      }
      setIsLoading("success");
      setTimeout(() => {
        setIsLoading(false);
      }, 5000);
    }
  }

  useEffect(() => {
    getVkrThemes();
  }, []);
  useEffect(() => {
    setIsBtnDisabled(!selectedTheme);
  }, [selectedTheme]);
  if (!data)
    return (
      <div className={cls.loaderContainer}>
        <div className={cls.loaderText}>Загружаем темы для выбора ВКР</div>
        <LinearLoader />
      </div>
    );
  // В Заявки / Выбор темы ВКР при `is_allow == false` выводится `message`.
  if (!data.is_allow)
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          {data.message && (
            <Text type="danger">
              <Icon name="warn" /> {data.message}
            </Text>
          )}
        </div>
        {data.event_status_name && (
          <Text>
            Статус заявки: &nbsp;
            <span>{data.event_status_name}</span>
          </Text>
        )}
        {data.theme && (
          <Text>
            Тема ВКР: &nbsp;
            <span>{data.theme}</span>
          </Text>
        )}
        {data.extended_theme && (
          <Text>
            Расширение темы:&nbsp;
            <span>{data.extended_theme}</span>
          </Text>
        )}
      </div>
    );

  const themes = data.themes;
  if (response?.errors) return <ErrataWidget errata={response} />;

  return (
    <div>
      <div className={cls.subtitle}>Тема ВКР</div>

      <div className={cls.dropdown} onClick={toggleDropdown}>
        <div className={cls.dropdownSelected}>
          <div className={cls.selectedTheme}>
            {selectedTheme
              ? themes.find((t) => t.diplom_theme_id === selectedTheme)
                  .diplom_theme_name
              : "Выбрать из списка"}
          </div>
          {isOpen ? <Icon name="caret_up" /> : <Icon name="caret_down" />}
        </div>
        {isOpen && (
          <div className={cls.dropdownMenu}>
            {themes.map((theme) => (
              <div
                key={theme.diplom_theme_id}
                className={cls.dropdownItem}
                onClick={() => selectTheme(theme)}
              >
                {theme.diplom_theme_name}
              </div>
            ))}
          </div>
        )}
      </div>

      <div>
        <div>Расширение темы</div>
        <textarea
          className={cls.textarea}
          maxLength={200}
          value={spreadTheme}
          onChange={(e) => setSpreadTheme(e.target.value)}
        />
      </div>

      <div className={cls.btnContainer}>
        <Button
          onClick={choiseVkrTheme}
          disabled={isBtnDisabled}
          type="primary"
        >
          {isLoading === true ? <Icon name="loading" /> : "Подтвердить"}
        </Button>
      </div>
      <Snackbar message="Успех!" open={isLoading === "success"} />
    </div>
  );
}

export default ModalAttestationTheme;
/* Формат данных:
{
  "is_allow": false,
  "message": "Выбор темы ВКР недоступен",
  "event_status_name": "",
  "themes": []
}
*/
